import { Pipe, PipeTransform } from '@angular/core';
import { DatesSummary } from '../../../entities';
import { isSameDay } from 'date-fns';

@Pipe({
  name: 'stageTitle',
  standalone: true,
})
export class StageTitlePipe implements PipeTransform {
  transform(summary: DatesSummary | null | undefined): string | null {
    if (!summary) return null;

    if (summary.state === 'NotStarted') return 'When are you planning to go?';

    if (summary.state === 'GatheringAvailability' && summary.rangeCriteria)
      return isSameDay(summary.rangeCriteria.start, summary.rangeCriteria.end)
        ? 'Gathering availability for'
        : 'Gathering availability between';

    if (summary.selectedDates)
      return isSameDay(summary.selectedDates.start, summary.selectedDates.end)
        ? 'Trip date'
        : 'Trip dates';

    return null;
  }
}
